// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { ShipmentCollectionModel, ShipmentModel } from "@store/Framework/Types/ApiModels";
import { GetShipmentsApiParameter } from "@store/Framework/Services/ShipmentService";
import ShipmentsState from "@store/Framework/Store/Greif/Data/Shipments/ShipmentsState";
import { Draft } from "immer";

const initialState: ShipmentsState = {
    isLoading: {},
    idByShipmentNumber: {},
    byId: {},
    dataViews: {},
    errorStatusCodeById: {},
};

const actions = {
    "Greif/Data/Shipments/BeginLoadShipments": (
        draft: Draft<ShipmentsState>,
        action: { parameter: GetShipmentsApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },

    "Greif/Data/Shipments/CompleteLoadShipments": (
        draft: Draft<ShipmentsState>,
        action: { parameter: GetShipmentsApiParameter; collection: ShipmentCollectionModel },
    ) => {
        setDataViewLoaded(
            draft,
            action.parameter,
            action.collection,
            collection => collection.shipments!,
            shipment => storeIdByShipmentNumber(draft, shipment),
        );
    },

    "Greif/Data/Shipments/FailedToLoadShipment": (
        draft: Draft<ShipmentsState>,
        action: { shipmentNumber: string; status: number },
    ) => {
        delete draft.isLoading[action.shipmentNumber];
        if (draft.errorStatusCodeById) {
            draft.errorStatusCodeById[action.shipmentNumber] = action.status;
        }
    },

    "Greif/Data/Shipments/Reset": () => {
        return initialState;
    },
};

function storeIdByShipmentNumber(draft: Draft<ShipmentsState>, shipment: ShipmentModel) {
    if (shipment.shipmentNumber) {
        draft.idByShipmentNumber[shipment.shipmentNumber] = shipment.id;
    }
}

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifDataShipmentsActions = Parameters<typeof reducer>[1];
export default reducer;
